<script>
export default {
    props: {
        isLive: {
            type: Boolean,
            required: true,
        },
        endedAt: {
            type: String,
            default: null,
        },
    },
    computed: {
        text() {
            if (this.isLive) {
                return 'En live'
            } else {
                if (this.endedAt) {
                    return 'Terminé'
                } else {
                    return 'Bientôt'
                }
            }
        },
    },
}
</script>

<template>
    <span :class="$style.wrapper">
        <div :class="[$style.dot, isLive ? $style.dotGreen : '', endedAt ? $style.dotFull : $style.dotOutlined]" />
        <span :class="$style.status">
            {{ text }}
        </span>
    </span>
</template>

<style lang="scss" module>
@import '@design';

.wrapper {
    display: flex;
    align-items: center;
}
.dot {
    display: block;
    width: 0.375rem;
    height: 0.375rem;
    margin-right: 0.375rem;
    border-radius: 50%;
    &.dotGreen {
        background: var(--color-success);
    }
    &.dotFull {
        background: white;
    }
    &.dotOutlined {
        border: 1px solid white;
    }
}
</style>
